import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
const shortcuts = [
    { id: 1, title: 'Profile Settings', description: 'Update your personal info' },
    { id: 2, title: 'Privacy Controls', description: 'Manage your data' },
    { id: 3, title: 'Connected Apps', description: 'View linked accounts' }
];

const Shortcuts = () => (
  <Grid container spacing={2}>
    {shortcuts.map((shortcut) => (
      <Grid item xs={12} sm={6} md={4} key={shortcut.id}>
        <Card>
          <CardContent>
            <Typography variant="h6">{shortcut.title}</Typography>
            <Typography>{shortcut.description}</Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
);

export default Shortcuts;
